import m from "react";
import { ark as i } from "@ark-ui/react";
import { styled as n } from "@huspy/styled-system/jsx";
import { badgeRecipe as a } from "@huspy/styled-system/recipes";
import { renderIcon as c } from "../../utils/render-icon.mjs";
const d = n(i.div, a);
function p(e) {
  const { children: r, leftSection: t, ...o } = e;
  return /* @__PURE__ */ m.createElement(d, { ...o }, c(t), r);
}
p.displayName = "Badge";
export {
  p as Badge
};
